import { IItem } from "@interfaces/user/items";
import { createContext, useContext } from "react";

export const ItemContext = createContext<IItem>(undefined as any);
export const ItemProvider = ItemContext.Provider;

export function useItemContext(): IItem | undefined {
    return useContext(ItemContext);
}